"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageLayer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const colormap_1 = __importDefault(require("colormap"));
const __1 = require("..");
function CoverageLayer(_a) {
    var { coverageData } = _a, props = __rest(_a, ["coverageData"]);
    return (jsx_runtime_1.jsx(jsx_runtime_1.Fragment, { children: coverageData.features.map(feature => {
            var _a, _b, _c;
            return (jsx_runtime_1.jsx(__1.GeoJSONFeature, Object.assign({}, props, { feature: feature, opacity: props.opacity === undefined ? 0.7 : props.opacity, backgroundColor: !((_a = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _a === void 0 ? void 0 : _a.signalStrength)
                    ? 'transparent'
                    : getColor((_c = (_b = feature === null || feature === void 0 ? void 0 : feature.properties) === null || _b === void 0 ? void 0 : _b.signalStrength) !== null && _c !== void 0 ? _c : 0), renderMode: "image" }), void 0));
        }) }, void 0));
}
exports.CoverageLayer = CoverageLayer;
function getColor(value) {
    const clamped = Math.max(min, Math.min(max, value));
    const percentage = (clamped - min) / (max - min);
    return colors[Math.floor(percentage * steps - 1)];
}
const steps = 100;
const colormap = [
    { value: 0, rgb: [0, 255, 0, 0] },
    { value: 0.1, rgb: [0, 255, 0, 0.5] },
    { value: 0.3, rgb: [255, 255, 0, 0.9] },
    { value: 0.7, rgb: [230, 10, 0, 1] },
    { value: 1, rgb: [230, 10, 0, 1] },
];
const { min, max } = colormap.reduce(({ max, min }, { value }) => ({ max: Math.max(max, value), min: Math.min(min, value) }), {
    max: colormap[0].value,
    min: colormap[0].value,
});
const colors = colormap_1.default({
    colormap: colormap.map(definition => ({
        index: (definition.value - min) / (max - min),
        rgb: definition.rgb,
    })),
    nshades: 100,
    format: 'rgbaString',
    alpha: 1,
});
//# sourceMappingURL=index.js.map